'use client'
import Link from "next/link";
import { Supplement } from "../utils/supplements";
import HeaderNavItem from "./HeaderNavItem";
import HeaderSubtitle from "./HeaderSubtitle";
import LanguageSwitcher from "./LanguageSwitcher";
import { usePathname } from "next/navigation";

export const HeaderNavItems = ({ bottom = false, supplements, homepage }: { bottom?: boolean, supplements: Supplement[], homepage: boolean }) => {
  let reorderedSupplements = [...supplements];
  
  if (reorderedSupplements.length > 4) {
    const [item0, item1, item2, item3, item4] = reorderedSupplements;
    reorderedSupplements = [item1, item4, item3, item0, item2]
  }

  return (
    <nav className={`z-1 flex flex-wrap sm:gap-12 text-xl font-system-serif sm:py-2 ${homepage ? 'pl-2 mb-8 sm:mb-0' : 'mb-0'} items-center justify-between sm:justify-center ${homepage ? 'w-auto' : 'w-full'}`}>
      {!homepage && <> 
        <Link href="/" className="no-underline sm:mr-auto">
          <h1 className="mb-0 font-bold text-3xl whitespace-nowrap">AI 2027</h1>
        </Link>
      </>}
      <LanguageSwitcher bottom={bottom} />

      <HeaderNavItem key="summary" href="https://ai-2040.com" target="_blank">
        AI 2040
      </HeaderNavItem>
      <div className="relative group">
        <HeaderNavItem key="research" href="/research">
          Supplements
        </HeaderNavItem>
        <div className={`absolute ${bottom ? 'bottom-[100%]' : 'top-[100%]'} w-[180px] hidden md:group-hover:block text-foreground right-0 font-sans text-sm [font-variant:normal] shadow-lg pb-2 pt-2 rounded bg-background border border-black z-50`}>
          <span>
            <Link href="/summary" className="block py-2 whitespace-no-wrap no-underline text-med p-4 hover:bg-[var(--accent)] hover:text-background">
              Summary
            </Link>
            <hr className="bg-dull-foreground w-[90%] mx-auto h-0 my-0" />
          </span>
          {reorderedSupplements.map(({ slug, title }, i, arr) => (
            <span key={slug}>
              <Link
                key={slug}
                href={`/research/${slug}`}
                className="block py-2 whitespace-no-wrap no-underline text-med p-4 hover:bg-[var(--accent)] hover:text-background"
              >
                {title}
              </Link>
              {i < arr.length - 1 && <hr key={`${slug}-${i}`} className="bg-dull-foreground w-[90%] mx-auto h-0 my-0" />}
            </span>
          ))}
        </div>
      </div>
      <HeaderNavItem key="about" href="/about" box>
        About
      </HeaderNavItem>

    </nav>
  )
}
export default function Header({ supplements }: { supplements: Supplement[] }) {
  const pathname = usePathname();
  // Treat translated versions (/es, /es/summary, ...) like their English counterparts
  const basePathname = pathname.replace(/^\/(es|fr|it)(?=\/|$)/, '') || '/';
  const isHomepage = (basePathname === '/') || (basePathname === '/summary');
  return (
    <nav className="flex flex-col [grid-area:header] z-1">
      <div className={`flex ${isHomepage ? 'flex-col-reverse sm:flex-row' : 'flex-row items-center'} justify-between mr-[1.5px] mt-0 sm:mt-8`}>
        {isHomepage &&
          <Link href="/" className="no-underline">
            <h1 className="mb-4 mt-2 whitespace-nowrap">
              AI 2027
            </h1>
          </Link>
        }
        <HeaderNavItems supplements={supplements} homepage={isHomepage} />
      </div>
      {isHomepage && <HeaderSubtitle />}
      {/* <div className="w-full h-[640px]">
        <img src="/ai-timeline-diagram4.svg" className="absolute left-0 w-[100vw] mt-[-120px]" />
      </div> */}

    </nav>
  );
}